import { Box, Stack, Typography } from '@mui/material'
import { Timer20Regular } from '@/components/Icon'
import MarkdownRenderer from '../MarkdownRenderer'
import { phaseBadgeSx, phaseCardSx, phaseTimeframeSx } from './phaseListSx'

/**
 * One phase of a plan.
 *
 * The timeframe chip pairs its colour with a clock icon and a text label
 * (P4.1) — colour alone never carries the meaning. The card is an
 * `<article>` with an accessible name so a screen reader announces "Phase 2,
 * Harden" rather than reading an unlabelled group of text.
 */
export default function PhaseCard({ phase }) {
  const label = `Phase ${phase.index}: ${phase.name}`

  return (
    <Box component="article" aria-label={label} sx={phaseCardSx}>
      <Stack direction="row" sx={{ alignItems: 'baseline', gap: 1, flexWrap: 'wrap' }}>
        <Box component="span" sx={phaseBadgeSx} aria-hidden>
          Phase {phase.index}
        </Box>
        <Typography component="h3" sx={{ m: 0, font: 'inherit', fontWeight: 650 }}>
          {phase.name}
        </Typography>
        {phase.timeframe ? (
          <Stack direction="row" component="span" sx={phaseTimeframeSx}>
            <Timer20Regular fontSize={13} aria-hidden />
            {phase.timeframe}
          </Stack>
        ) : null}
      </Stack>
      {phase.body ? <MarkdownRenderer text={phase.body} /> : null}
    </Box>
  )
}
